import { useEffect, useRef } from 'react'
import type { ChangeEvent } from '@/shared/api/types'
import { useMarkClientEventsRead } from '../model'

/** Отмечает верхнюю видимую границу ленты без прямого сетевого вызова. */
export function useMarkEventsReadOnView(events: ChangeEvent[], unread: number) {
  const { mutate: markRead } = useMarkClientEventsRead()
  const markedId = useRef<number | null>(null)
  const newestId = events.reduce<number | null>(
    (latest, event) => (latest === null || event.id > latest ? event.id : latest),
    null,
  )

  useEffect(() => {
    if (unread <= 0 || newestId === null || markedId.current === newestId) return

    markedId.current = newestId
    markRead(newestId)
  }, [markRead, newestId, unread])
}
